var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"width":"375","min-height":"200"}},[_c('p',{staticClass:"mx-3"},[_vm._v(_vm._s(_vm.$t('authentication...')))])])}
var staticRenderFns = []

export { render, staticRenderFns }